import type {MouseEvent} from "react";
import classNames from "classnames";

import {SearchComboboxCloseIcon} from "../icons/SearchComboboxCloseIcon";
import type {ISearchComboboxFieldControlsProps} from "../types/ISearchComboboxFieldControlsProps";
import {SearchComboboxSpinner} from "./SearchComboboxSpinner";

import * as styles from "./SearchComboboxFieldControls.module.css";

const preventFocusLoss = (event: MouseEvent<HTMLButtonElement>) => event.preventDefault();

/**
 * Right-hand slot of a search field: the × that clears the query or, while a request is slow, the spinner in its place.
 * Renders nothing when there is neither.
 */
export const SearchComboboxFieldControls = (props: ISearchComboboxFieldControlsProps) => {
    const {size = "desktop", isBusy, showClear, onClear, clearLabel = "Wyczyść", className, dataTestId, clearDataTestId, spinnerDataTestId} = props;
    const isMobile = size === "mobile";

    if (!isBusy && !showClear) {
        return null;
    }

    return (
        <span className={classNames(styles.controls, isMobile && styles.controlsMobile, className)} data-testid={dataTestId}>
            {isBusy ? (
                <SearchComboboxSpinner size={isMobile ? 18 : 22} dataTestId={spinnerDataTestId} />
            ) : (
                <button
                    type="button"
                    className={styles.clear}
                    aria-label={clearLabel}
                    onMouseDown={preventFocusLoss}
                    onClick={onClear}
                    data-testid={clearDataTestId}
                >
                    <SearchComboboxCloseIcon size={isMobile ? 14 : 16} />
                </button>
            )}
        </span>
    );
};
import type {MouseEvent} from "react";
import classNames from "classnames";

import {SearchComboboxCloseIcon} from "../icons/SearchComboboxCloseIcon";
import type {ISearchComboboxFieldControlsProps} from "../types/ISearchComboboxFieldControlsProps";
import {SearchComboboxSpinner} from "./SearchComboboxSpinner";

import * as styles from "./SearchComboboxFieldControls.module.css";

const preventFocusLoss = (event: MouseEvent<HTMLButtonElement>) => event.preventDefault();

/**
 * Right-hand slot of a search field: the × that clears the query or, while a request is slow, the spinner in its place.
 * Renders nothing when there is neither.
 */
export const SearchComboboxFieldControls = (props: ISearchComboboxFieldControlsProps) => {
    const {size = "desktop", isBusy, showClear, onClear, clearLabel = "Wyczyść", className, dataTestId, clearDataTestId, spinnerDataTestId} = props;
    const isMobile = size === "mobile";

    if (!isBusy && !showClear) {
        return null;
    }

    return (
        <span className={classNames(styles.controls, isMobile && styles.controlsMobile, className)} data-testid={dataTestId}>
            {isBusy ? (
                <SearchComboboxSpinner size={isMobile ? 18 : 22} dataTestId={spinnerDataTestId} />
            ) : (
                <button
                    type="button"
                    className={styles.clear}
                    aria-label={clearLabel}
                    onMouseDown={preventFocusLoss}
                    onClick={onClear}
                    data-testid={clearDataTestId}
                >
                    <SearchComboboxCloseIcon size={isMobile ? 14 : 16} />
                </button>
            )}
        </span>
    );
};
